<template>
  <v-dialog
    v-model="active"
    width="90%"
    persistent
  >
    <v-card
      color="primary"
      tile
    >
      <v-card-title>
        <div class="text-h6">
          Registro de proceso de evaluación
        </div>
        <v-spacer />
        <v-btn
          icon
          color="error"
          class="px-4"
          @click="closeDialog()"
        >
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-stepper
                v-model="expedientePreaspiranteStepper"
                vertical
                class="primary"
              >
                <v-stepper-step
                  step="1"
                  color="secondary"
                >
                  Información de solicitud
                </v-stepper-step>
                <v-stepper-content
                  step="1"
                  class="primary"
                >
                  <v-container>
                    <v-row>
                      <v-col
                        cols="6"
                        offset="3"
                      >
                        <v-form v-model="infoProgramacionForm">
                          <v-row>
                            <v-col cols="12">
                              <v-autocomplete
                                v-model="programacion.fk_idSolicitud"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Elegir solicitud"
                                :rules="required"
                                :items="solicitudes"
                                item-value="idSolicitudes"
                                item-text="oficio"
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-select
                                v-model="programacion.fk_idCatMotivoEvaluacion"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Motivo de evaluación"
                                :rules="required"
                                :items="motivoEvaluacion"
                                item-value="id"
                                item-text="title"
                              />
                            </v-col>
                            <v-col cols="12">
                              <v-text-field
                                v-model="tarjetaInformativa"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Número de tarjeta informativa"
                                :rules="required"
                              />
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper--"
                        >
                          Paso anterior
                        </v-btn>
                        <v-btn
                          rounded
                          color="secondary"
                          class="px-4 mx-2"
                          :disabled="!programacion.fk_idSolicitud"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Siguiente paso
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
                <v-stepper-step
                  step="2"
                  color="secondary"
                >
                  Fecha evaluación médica
                </v-stepper-step>
                <v-stepper-content
                  step="2"
                  class="primary"
                >
                  <v-container>
                    <v-row>
                      <v-col
                        cols="6"
                        offset="3"
                      >
                        <v-form v-model="fechaEvaluacionMedicaForm">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :value="tarjetaInformativa"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Tarjeta informativa"
                                readonly
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              <v-date-picker
                                v-model="programacion.fechaEvaluacionMedica"
                                locale="es"
                                color="secondary"
                                no-title
                                full-width
                              />
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.horaEvaluacionMedica"
                                    type="number"
                                    min="0"
                                    max="23"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Horas"
                                    :rules="horaRules"
                                  />
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.minutosEvaluacionMedica"
                                    type="number"
                                    min="0"
                                    max="59"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Minutos"
                                    :rules="minutoRules"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper--"
                        >
                          Paso anterior
                        </v-btn>
                        <v-btn
                          rounded
                          color="secondary"
                          class="px-4 mx-2"
                          :disabled="!fechaEvaluacionMedicaForm"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Siguiente paso
                        </v-btn>
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Omitir evaluación
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
                <v-stepper-step
                  step="3"
                  color="secondary"
                >
                  Fecha evaluación toxicológica
                </v-stepper-step>
                <v-stepper-content step="3">
                  <v-container>
                    <v-row>
                      <v-col
                        cols="6"
                        offset="3"
                      >
                        <v-form v-model="fechaEvaluacionToxicologicaForm">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :value="tarjetaInformativa"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Tarjeta informativa"
                                readonly
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              <v-date-picker
                                v-model="programacion.fechaEvaluacionToxicologica"
                                locale="es"
                                color="secondary"
                                no-title
                                full-width
                              />
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.horaEvaluacionToxicologica"
                                    type="number"
                                    min="0"
                                    max="23"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Horas"
                                    :rules="horaRules"
                                  />
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.minutosEvaluacionToxicologica"
                                    type="number"
                                    min="0"
                                    max="59"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Minutos"
                                    :rules="minutoRules"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper--"
                        >
                          Paso anterior
                        </v-btn>
                        <v-btn
                          rounded
                          color="secondary"
                          class="px-4 mx-2"
                          :disabled="!fechaEvaluacionToxicologicaForm"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Siguiente paso
                        </v-btn>
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Omitir evaluación
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
                <v-stepper-step
                  step="4"
                  color="secondary"
                >
                  Fecha evaluación psicológica
                </v-stepper-step>
                <v-stepper-content step="4">
                  <v-container>
                    <v-row>
                      <v-col
                        cols="6"
                        offset="3"
                      >
                        <v-form v-model="fechaEvaluacionPsicologicaForm">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :value="tarjetaInformativa"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Tarjeta informativa"
                                readonly
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              <v-date-picker
                                v-model="programacion.fechaEvaluacionPsicologica"
                                locale="es"
                                color="secondary"
                                no-title
                                full-width
                              />
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.horaEvaluacionPsicologica"
                                    type="number"
                                    min="0"
                                    max="23"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Horas"
                                    :rules="horaRules"
                                  />
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.minutosEvaluacionPsicologica"
                                    type="number"
                                    min="0"
                                    max="59"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Minutos"
                                    :rules="minutoRules"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper--"
                        >
                          Paso anterior
                        </v-btn>
                        <v-btn
                          rounded
                          color="secondary"
                          class="px-4 mx-2"
                          :disabled="!fechaEvaluacionPsicologicaForm"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Siguiente paso
                        </v-btn>
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Omitir evaluación
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
                <v-stepper-step
                  step="5"
                  color="secondary"
                >
                  Fecha registro en SITE (Toma de fotografía y biométricos)
                </v-stepper-step>
                <v-stepper-content step="5">
                  <v-container>
                    <v-row>
                      <v-col
                        cols="6"
                        offset="3"
                      >
                        <v-form v-model="fechaRegistroSiteForm">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :value="tarjetaInformativa"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Tarjeta informativa"
                                readonly
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              <v-date-picker
                                v-model="programacion.fechaRegistroSite"
                                locale="es"
                                color="secondary"
                                no-title
                                full-width
                                :rules="required"
                              />
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.horaEvaluacionSite"
                                    type="number"
                                    min="0"
                                    max="23"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Horas"
                                    :rules="horaRules"
                                  />
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.minutosEvaluacionSite"
                                    type="number"
                                    min="0"
                                    max="59"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Minutos"
                                    :rules="minutoRules"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper--"
                        >
                          Paso anterior
                        </v-btn>
                        <v-btn
                          rounded
                          color="secondary"
                          class="px-4 mx-2"
                          :disabled="!fechaRegistroSiteForm"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Siguiente paso
                        </v-btn>
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Omitir evaluación
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
                <v-stepper-step
                  step="6"
                  color="secondary"
                >
                  Fecha entrevista ISE (Investigación Socioeconómica)
                </v-stepper-step>
                <v-stepper-content step="6">
                  <v-container>
                    <v-row>
                      <v-col
                        cols="6"
                        offset="3"
                      >
                        <v-form v-model="fechaEntrevistaIseForm">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :value="tarjetaInformativa"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Tarjeta informativa"
                                readonly
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              <v-date-picker
                                v-model="programacion.fechaEntrevistaIse"
                                locale="es"
                                color="secondary"
                                no-title
                                full-width
                              />
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.horaEntrevistaIse"
                                    type="number"
                                    min="0"
                                    max="23"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Horas"
                                    :rules="horaRules"
                                  />
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.minutosEntrevistaIse"
                                    type="number"
                                    min="0"
                                    max="59"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Minutos"
                                    :rules="minutoRules"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper--"
                        >
                          Paso anterior
                        </v-btn>
                        <v-btn
                          rounded
                          color="secondary"
                          class="px-4 mx-2"
                          :disabled="!fechaEntrevistaIseForm"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Siguiente paso
                        </v-btn>
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Omitir evaluación
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
                <v-stepper-step
                  step="7"
                  color="secondary"
                >
                  Fecha evaluación poligráfica
                </v-stepper-step>
                <v-stepper-content step="7">
                  <v-container>
                    <v-row>
                      <v-col
                        cols="6"
                        offset="3"
                      >
                        <v-form v-model="fechaEvaluacionPoligraficaForm">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :value="tarjetaInformativa"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Tarjeta informativa"
                                readonly
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              <v-date-picker
                                v-model="programacion.fechaEvaluacionPoligrafica"
                                locale="es"
                                color="secondary"
                                no-title
                                full-width
                              />
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.horaEvaluacionPoligrafica"
                                    type="number"
                                    min="0"
                                    max="23"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Horas"
                                    :rules="horaRules"
                                  />
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.minutosEvaluacionPoligrafica"
                                    type="number"
                                    min="0"
                                    max="59"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Minutos"
                                    :rules="minutoRules"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper--"
                        >
                          Paso anterior
                        </v-btn>
                        <v-btn
                          rounded
                          color="secondary"
                          class="px-4 mx-2"
                          :loading="loading"
                          :disabled="!fechaEvaluacionPoligraficaForm"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Siguiente paso
                        </v-btn>
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper++"
                        >
                          Omitir evaluación
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
                <v-stepper-step
                  step="8"
                  color="secondary"
                >
                  Fecha estimada de integración
                </v-stepper-step>
                <v-stepper-content step="8">
                  <v-container>
                    <v-row>
                      <v-col
                        cols="6"
                        offset="3"
                      >
                        <v-form v-model="fechaEvaluacionIntegracionForm">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                :value="tarjetaInformativa"
                                rounded
                                filled
                                dense
                                background-color="primary"
                                color="secondary"
                                label="Tarjeta informativa"
                                readonly
                              />
                            </v-col>
                            <v-col
                              cols="12"
                              align="center"
                            >
                              <v-date-picker
                                v-model="programacion.fechaEvaluacionIntegracion"
                                locale="es"
                                color="secondary"
                                no-title
                                full-width
                              />
                              <v-row>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.horaEvaluacionIntegracion"
                                    type="number"
                                    min="0"
                                    max="23"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Horas"
                                    :rules="horaRules"
                                  />
                                </v-col>
                                <v-col cols="6">
                                  <v-text-field
                                    v-model.number="programacion.minutosEvaluacionIntegracion"
                                    type="number"
                                    min="0"
                                    max="59"
                                    rounded
                                    filled
                                    dense
                                    background-color="primary"
                                    color="secondary"
                                    label="Minutos"
                                    :rules="minutoRules"
                                  />
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                      <v-col
                        cols="12"
                        align="center"
                      >
                        <v-btn
                          text
                          color="secondary"
                          class="px-4 mx-2"
                          @click="expedientePreaspiranteStepper--"
                        >
                          Paso anterior
                        </v-btn>
                        <v-btn
                          rounded
                          color="secondary"
                          class="px-4 mx-2"
                          :loading="loading"
                          :disabled="!fechaEvaluacionIntegracionForm
                            || !programacion.fechaEvaluacionIntegracion || loading"
                          @click="triggerSaveProgramacion()"
                        >
                          Realizar programación
                        </v-btn>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-stepper-content>
              </v-stepper>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';
import createPersonaApiRepository from '../../modules/persona/infrastructure/PersonaApiRepository';
import notifyProcesoEvaluacion from '../../modules/persona/application/notifyProcesoEvaluacion';

export default {
  props: {
    active: {
      type: Boolean,
    },

    solicitud: {
      type: Object,
      default: () => null,
      required: false,
    },

    expediente: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      nuevoExpedienteDialog: false,
      loading: false,

      expedientePreaspiranteStepper: 1,

      selectedExpediente: null,

      tarjetaInformativa: '',

      programacion: {
        fk_idSolicitud: null,
        fk_idCatTipoExpediente: 1,
        folio: null,
        fk_idCatMotivoEvaluacion: null,
        fechaEvaluacionMedica: null,
        fechaEvaluacionToxicologica: null,
        fechaEvaluacionPsicologica: null,
        fechaRegistroSite: null,
        fechaEntrevistaIse: null,
        fechaEvaluacionPoligrafica: null,
        fechaEvaluacionIntegracion: null,
        fk_idCatEstatusProgramacion: null,
        oficioSolicitud: '',
        oficioProgramacion: '',
      },

      oficioSolicitudDerivacionMedica: '',
      oficioSolicitudDerivacionToxicologica: '',
      oficioSolicitudDerivacionPsicologica: '',
      oficioSolicitudDerivacionRegistroSite: '',
      oficioSolicitudDerivacionIse: '',
      oficioSolicitudDerivacionPoligrafica: '',
      oficioSolicitudDerivacionIntegracion: '',

      // Forms
      infoProgramacionForm: false,
      fechaEvaluacionMedicaForm: false,
      fechaEvaluacionToxicologicaForm: false,
      fechaEvaluacionPsicologicaForm: false,
      fechaRegistroSiteForm: false,
      fechaEntrevistaIseForm: false,
      fechaEvaluacionPoligraficaForm: false,
      fechaEvaluacionIntegracionForm: false,

      // Rules
      required: [(v) => !!v || 'Este campo es requerido.'],
      horaRules: [(v) => (v >= 0 && v <= 23) || 'Verifique este campo.'],
      minutoRules: [(v) => (v >= 0 && v <= 59) || 'Verifique este campo.'],
    };
  },

  computed: {
    ...mapGetters('motivoEvaluacion', {
      motivoEvaluacion: 'getMotivoEvaluacion',
    }),

    ...mapGetters('expediente', {
      expedientes: 'getExpedientes',
      expedienteId: 'getSavedExpedienteId',
      expedientePersonal: 'getExpedientesPersonal',
    }),

    ...mapGetters('programacionEvaluacion', {
      idProgramacionEvaluacion: 'getIdProgramacionEvaluacion',
    }),

    ...mapGetters('estatusProgramacion', {
      estatusProgramacion: 'getEstatusProgramacion',
    }),

    ...mapGetters('solicitudes', {
      idSolicitud: 'getIdSolicitud',
      solicitudes: 'getSolicitudes',
    }),

    getNombreExpediente() {
      if (this.selectedExpediente) {
        // return this.getFullName(this.selectedExpediente.Personal)
        return 'Hello';
      } return '';
    },
  },

  methods: {
    ...mapActions('programacionEvaluacion', ['saveProgramacionEvaluacion', 'fetchProgramacionesEvaluaciones']),
    ...mapActions('derivaciones', ['saveDerivacion']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),

    closeDialog() {
      this.selectedExpediente = null;
      this.expedientePreaspiranteStepper = 1;
      this.loading = false;
      this.$emit('close');
    },

    async triggerSaveProgramacion() {
      this.loading = true;

      try {
        this.programacion.idExpediente = this.expediente.idExpediente;

        this.formatFechasEvaluaciones();

        await this.saveProgramacionEvaluacion(this.programacion);

        if (this.fechaEvaluacionPsicologicaForm) {
          await this.saveDerivacion({
            idProgramacionEvaluacion: this.idProgramacionEvaluacion,
            oficioSolicitud: this.oficioSolicitudDerivacionPsicologica,
            fechaOficioSolicitud: moment(this.programacion.fechaEvaluacionPsicologica).format('DD/MM/YYYY'),
            fk_idEquipoApplication: 17,
            fk_idCatEstatus: 1,
            fk_idUsuario: parseInt(localStorage.getItem('idUsuario'), 10),
          });
        }

        if (this.fechaEvaluacionPoligraficaForm) {
          await this.saveDerivacion({
            idProgramacionEvaluacion: this.idProgramacionEvaluacion,
            oficioSolicitud: this.oficioSolicitudDerivacionPoligrafica,
            fechaOficioSolicitud: moment(this.programacion.fechaEvaluacionPoligrafica).format('DD/MM/YYYY'),
            fk_idEquipoApplication: 18,
            fk_idCatEstatus: 1,
            fk_idUsuario: parseInt(localStorage.getItem('idUsuario'), 10),
          });
        }

        if (this.fechaEvaluacionMedicaForm) {
          await this.saveDerivacion({
            idProgramacionEvaluacion: this.idProgramacionEvaluacion,
            oficioSolicitud: this.oficioSolicitudDerivacionMedica,
            fechaOficioSolicitud: moment(this.programacion.fechaEvaluacionMedica).format('DD/MM/YYYY'),
            fk_idEquipoApplication: 19,
            fk_idCatEstatus: 1,
            fk_idUsuario: parseInt(localStorage.getItem('idUsuario'), 10),
          });
        }

        if (this.fechaEntrevistaIseForm) {
          await this.saveDerivacion({
            idProgramacionEvaluacion: this.idProgramacionEvaluacion,
            oficioSolicitud: this.oficioSolicitudDerivacionIse,
            fechaOficioSolicitud: moment(this.programacion.fechaEntrevistaIse).format('DD/MM/YYYY'),
            fk_idEquipoApplication: 20,
            fk_idCatEstatus: 1,
            fk_idUsuario: parseInt(localStorage.getItem('idUsuario'), 10),
          });
          await this.saveDerivacion({
            idProgramacionEvaluacion: this.idProgramacionEvaluacion,
            oficioSolicitud: this.oficioSolicitudDerivacionIse,
            fechaOficioSolicitud: moment(this.programacion.fechaEntrevistaIse).format('DD/MM/YYYY'),
            fk_idEquipoApplication: 21,
            fk_idCatEstatus: 1,
            fk_idUsuario: parseInt(localStorage.getItem('idUsuario'), 10),
          });
        }

        if (this.fechaRegistroSiteForm) {
          await this.saveDerivacion({
            idProgramacionEvaluacion: this.idProgramacionEvaluacion,
            oficioSolicitud: this.oficioSolicitudDerivacionRegistroSite,
            fechaOficioSolicitud: moment(this.programacion.fechaRegistroSite).format('DD/MM/YYYY'),
            fk_idEquipoApplication: 22,
            fk_idCatEstatus: 1,
            fk_idUsuario: parseInt(localStorage.getItem('idUsuario'), 10),
          });
        }

        await this.saveDerivacion({
          idProgramacionEvaluacion: this.idProgramacionEvaluacion,
          oficioSolicitud: this.oficioSolicitudDerivacionIntegracion,
          fechaOficioSolicitud: moment(this.programacion.fechaEvaluacionIntegracion).format('DD/MM/YYYY'),
          fk_idEquipoApplication: 23,
          fk_idCatEstatus: 1,
          fk_idUsuario: parseInt(localStorage.getItem('idUsuario'), 10),
        });

        if (this.expediente.Personal.vigenciaAnio !== 0) {
          const repository = createPersonaApiRepository();
          await notifyProcesoEvaluacion(
            repository,
            this.expediente,
            this.programacion,
            this.solicitudes.find((solicitud) => solicitud.idSolicitudes === this.programacion.fk_idSolicitud).asunto,
            this.solicitudes.find((solicitud) => solicitud.idSolicitudes === this.programacion.fk_idSolicitud).oficio,
          );
        }

        await this.fetchProgramacionesEvaluaciones();
        this.SET_SNACKBAR_MESSAGE('Programación de evaluaciones realizada correctamente.');
      } catch (error) {
        this.SET_SNACKBAR_MESSAGE('Error al generar programación de evaluaciones.');
      }

      this.closeDialog();
    },

    formatFechasEvaluaciones() {
      this.programacion.fechaEvaluacionMedica = `${this.programacion.fechaEvaluacionMedica
      } ${
        this.programacion.horaEvaluacionMedica
      }:${
        this.programacion.minutosEvaluacionMedica
      }:00`;

      this.programacion.fechaEvaluacionMedica = moment(this.programacion.fechaEvaluacionMedica).format('YYYY-MM-DD HH:mm:ss');

      this.programacion.fechaEvaluacionToxicologica = `${this.programacion.fechaEvaluacionToxicologica
      } ${
        this.programacion.horaEvaluacionToxicologica
      }:${
        this.programacion.minutosEvaluacionToxicologica
      }:00`;

      this.programacion.fechaEvaluacionToxicologica = moment(this.programacion.fechaEvaluacionToxicologica).format('YYYY-MM-DD HH:mm:ss');

      this.programacion.fechaEvaluacionPsicologica = `${this.programacion.fechaEvaluacionPsicologica
      } ${
        this.programacion.horaEvaluacionPsicologica
      }:${
        this.programacion.minutosEvaluacionPsicologica
      }:00`;

      this.programacion.fechaEvaluacionPsicologica = moment(this.programacion.fechaEvaluacionPsicologica).format('YYYY-MM-DD HH:mm:ss');

      this.programacion.fechaRegistroSite = `${this.programacion.fechaRegistroSite} ${this.programacion.horaEvaluacionSite}:${this.programacion.minutosEvaluacionSite}:00`;

      this.programacion.fechaRegistroSite = moment(this.programacion.fechaRegistroSite).format('YYYY-MM-DD HH:mm:ss');

      this.programacion.fechaEntrevistaIse = `${this.programacion.fechaEntrevistaIse} ${this.programacion.horaEntrevistaIse}:${this.programacion.minutosEntrevistaIse}:00`;

      this.programacion.fechaEntrevistaIse = moment(this.programacion.fechaEntrevistaIse).format('YYYY-MM-DD HH:mm:ss');

      this.programacion.fechaEvaluacionPoligrafica = `${this.programacion.fechaEvaluacionPoligrafica
      } ${
        this.programacion.horaEvaluacionPoligrafica
      }:${
        this.programacion.minutosEvaluacionPoligrafica
      }:00`;

      this.programacion.fechaEvaluacionPoligrafica = moment(this.programacion.fechaEvaluacionPoligrafica).format('YYYY-MM-DD HH:mm:ss');

      this.programacion.fechaEvaluacionIntegracion = `${this.programacion.fechaEvaluacionIntegracion
      } ${
        this.programacion.horaEvaluacionIntegracion
      }:${
        this.programacion.minutosEvaluacionIntegracion
      }:00`;

      this.programacion.fechaEvaluacionIntegracion = moment(this.programacion.fechaEvaluacionIntegracion).format('YYYY-MM-DD HH:mm:ss');
    },
  },
};
</script>
